import axios from "axios"
import { useAuthStore } from "@/stores/authStore"

export const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL ?? "",
  headers: { "Content-Type": "application/json" },
  withCredentials: false,
})

api.interceptors.request.use((config) => {
  const token = useAuthStore.getState().token
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  // Let the browser set Content-Type automatically for FormData (includes boundary)
  if (config.data instanceof FormData) {
    delete config.headers["Content-Type"]
  }
  return config
})

api.interceptors.response.use(
  (res) => res,
  (error) => {
    const url: string = error.config?.url ?? ""
    const isAuthEndpoint = url.startsWith("/api/auth/")
    if (error.response?.status === 401 && !isAuthEndpoint) {
      useAuthStore.getState().logout()
      window.location.href = "/login"
    }
    return Promise.reject(error)
  }
)
